import React, { useEffect, useState } from 'react'
import Card from '../../../../common/card/Card'
import { useParams } from 'react-router-dom'
import { QueryClient, useQuery } from '@tanstack/react-query'
import { performRequest } from '../../../../common/utils'
import Loader from '../../../../common/loader/Loader'
import MemberPresetsTable from './MemberPresetsTable'
import useMemberTable from '../context/MemberTableContext'


const MemberPresets = ({ teamType, refreshTeamData }) => {

  const params = useParams()
  const teamId = params.team_id
  const [ responseMessage, setResponseMessage ] = useState('')
  const { setRefetchMemberPresets, setSelectedMemberPreset, setSelectedModal, setSelectedBulkUser } = useMemberTable()

  const queryClient = new QueryClient()

  const {
    isLoading,
    isPending,
    isFetching,
    isError,
    error,
    refetch,
    data } = useQuery({
      queryKey: ['get_org_member_presets'],
      queryFn: requestOrgMemberPresets,
      refetchOnWindowFocus: false
    }, queryClient)

    async function requestOrgMemberPresets() {
        const {
            group_dashboard: { nonce, base }
        } = window
        let url = base + 'membersync/licensing/v1/org/' + teamId + '/presets'

        const res = await fetch(`${url}`, {
            method: 'POST',
            body: JSON.stringify({
                type: 'member'
            }),
            headers: {
              'X-WP-Nonce': nonce,
              'Content-type': "application/json"
            },
            credentials: 'same-origin',
            processData: false,
            contentType: false,
        })

        if ( !res.ok ) throw Error(res.statusText)

        const resultJSON = await res.json()
        return resultJSON.response
    }

  useEffect(() => {
    setRefetchMemberPresets(() => refetch)
    setSelectedMemberPreset('')
    setSelectedModal('')
    setSelectedBulkUser('')
  }, [ refetch ])

  if( isLoading || isPending || isFetching ){
    return (
      <Loader type='spinner-dual-ring'/>
    )
  }

  if( isError ){
    return (
      <Card> 
        <strong> { error.message } </strong> 
      </Card>
    )
  }

  return (
    <>
      {
        responseMessage && responseMessage !== ''
        ? <Card> 
            <strong>{ responseMessage }</strong> 
          </Card>
        : data.length !== 0 &&
          <MemberPresetsTable memberPresetsData={ data } refetchPresets={ refreshTeamData } />
      }
    </>
  )
}

export default MemberPresets
